import CeHistoryModal from './CeHistoryModal';

export default CeHistoryModal;
